(() => {
  const CARD_SELECTOR = '.ewa-feature-card[data-ewa-variant-size-card]';

  const clean = (value) => String(value == null ? '' : value).trim();

  const parseConfig = (card) => {
    const node = card.querySelector('[data-ewa-size-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.warn('EWA variant size configuration could not be read.', error);
      return null;
    }
  };

  const setCardValue = (card, variantId) => {
    const config = parseConfig(card);
    const valueNode = card.querySelector('[data-ewa-feature-value]');
    if (!config || !valueNode) return;

    const id = variantId == null ? '' : String(variantId);
    const variantValue = id && config.variantSizes ? clean(config.variantSizes[id]) : '';
    const next = variantValue || clean(config.fallback) || '—';

    valueNode.textContent = next;
    card.classList.toggle('is-variant-resolved', Boolean(variantValue));
  };

  const initCards = (root = document) => {
    root.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      const config = parseConfig(card);
      if (config) setCardValue(card, config.selectedVariantId);
    });
  };

  // Primary Ecomus event: no parsing of option labels, only exact Shopify variant ID.
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    if (!variant || !variant.id) return;

    document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      const config = parseConfig(card);
      if (!config || !config.variantSizes) return;
      if (Object.prototype.hasOwnProperty.call(config.variantSizes, String(variant.id))) {
        setCardValue(card, variant.id);
      }
    });
  });

  // Theme-editor / picker fallback: read the real selected variant ID from the product form.
  document.addEventListener('change', (event) => {
    const picker = event.target && event.target.closest ? event.target.closest('hdt-variant-picker') : null;
    if (!picker) return;

    const formId = picker.getAttribute('form');
    if (!formId) return;

    window.setTimeout(() => {
      const form = document.getElementById(formId);
      const variantInput = form && form.querySelector('input[name="id"]');
      const variantId = variantInput ? clean(variantInput.value) : '';
      if (!variantId) return;

      document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
        const config = parseConfig(card);
        if (!config || !config.variantSizes) return;
        if (Object.prototype.hasOwnProperty.call(config.variantSizes, String(variantId))) {
          setCardValue(card, variantId);
        }
      });
    }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCards(), { once: true });
  } else {
    initCards();
  }

  document.addEventListener('shopify:section:load', (event) => initCards(event.target || document));
})();
